var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArticle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66667 9V7.33333H10.3333V9H3.66667ZM3.66667 5.66666V4H10.3333V5.66666H3.66667ZM2 10.6667H8.25C8.65278 10.6667 9.02778 10.7535 9.375 10.9271C9.72222 11.1007 10.0139 11.3472 10.25 11.6667L12 13.9583V2.33333H2V10.6667ZM2 15.6667H11.2083L8.9375 12.6875C8.85417 12.5764 8.75347 12.4896 8.63542 12.4271C8.51736 12.3646 8.38889 12.3333 8.25 12.3333H2V15.6667ZM12 17.3333H2C1.54167 17.3333 1.14931 17.1701 0.822919 16.8438C0.49653 16.5174 0.333336 16.125 0.333336 15.6667V2.33333C0.333336 1.875 0.49653 1.48264 0.822919 1.15625C1.14931 0.829859 1.54167 0.666664 2 0.666664H12C12.4583 0.666664 12.8507 0.829859 13.1771 1.15625C13.5035 1.48264 13.6667 1.875 13.6667 2.33333V15.6667C13.6667 16.125 13.5035 16.5174 13.1771 16.8438C12.8507 17.1701 12.4583 17.3333 12 17.3333Z",
    fill: "#13214E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticle);
export default __webpack_public_path__ + "static/media/article.6551db50d0db784ce32ca2bf7e053ee1.svg";
export { ForwardRef as ReactComponent };